"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    icon: {
      borderRadius: 4,
      width: 16,
      height: 16,
      boxShadow: "inset 0 0 0 1px ".concat(_colors["default"].iconLight, ", inset 0 -1px 0 ").concat(_colors["default"].iconLight),
      'input:disabled ~ &': {
        background: _colors["default"].iconLight
      }
    },
    checkedIcon: {
      backgroundColor: _colors["default"].purple,
      boxShadow: 'none',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""'
      }
    }
  };
};

exports.styles = styles;